import ScaleToFit from "./ScaleToFit";
import FigureImageExpansionContainer from "./FigureImageExpansionContainer";
import ExpansionPreviewContainer from "./ExpansionPreviewContainer";
import useElementDims from "./useElementDims";
import DimShower from "./DimShower";

import { useState, useRef } from 'react';
export default function ExpansionPreviewContainerWrapper({
  someImageHasBeenChosen,
  view,
  layout,
  expansionPreviewContainerArgs,
  //expansionPreviewContainer,
}){

  const containerRef = useRef();
  const containerBounds = useElementDims(containerRef);


  let {width,height} = containerBounds || {}


  let { figurePanelId, cellLocation, previewValue, expDims } = expansionPreviewContainerArgs;

  let expW1 = Object.fromEntries(Object.entries(expDims).map(([k,v]) => [k,v/expDims.w]));
  let expH1 = Object.fromEntries(Object.entries(expDims).map(([k,v]) => [k,v/expDims.h]));


  let expansionWidth;
  if( expW1.h * width > height ){
    expansionWidth = expH1.w * height;
  }else{
    expansionWidth = width;
  }



  let expansionPreviewContainer = (
    <ExpansionPreviewContainer {...expansionPreviewContainerArgs}>

      {expDims && <div style={{position:'fixed',top:0,left:0, background:'black',color:'cyan'}}>

        {JSON.stringify(expDims)}
      </div>}

      <FigureImageExpansionContainer {...{
        figurePanelId,
        width:expansionWidth,
        cellLocation,
        value:previewValue
      }}/>

      {false && width && height && 
        <ScaleToFit tag={"previewContainer"} dimensions={[width/4,height]}><FigureImageExpansionContainer {...{
        figurePanelId,
        width:width,//expansionWidth,
        cellLocation,
        value:previewValue
      }}/>
        </ScaleToFit>
          }

        {/*false & <NewScaleToFit dimensions={[
      containerWidth, // 2,
      containerHeight,// * 2
    ]} computeChildren={width => 
      <FigureImageExpansionContainer {...{
        figurePanelId,
        width:width??CONTAINER_WIDTH,
        cellLocation,
        value:previewValue
      }}/>
    } />*/}
    </ExpansionPreviewContainer>
  );

  
  return (
    <div ref={containerRef} container="expansion-preview" class="flex-expand" style={{
      minHeight:0,
      //border:'3px solid magenta',
      //overflow:'scroll',
    }}>
      {someImageHasBeenChosen && (
        <>

          {view==="layout" && layout}
          {view==="preview" && expansionPreviewContainer}
        </>)}
    </div>
  )


}
